export class EntityInformation {
    entityId: string;
    entityName: string;
    entityNamePart2: string;
    addressLine1: string;
    addressLine2: string;
    city: string;
    state: string;
    postalCode: string;
    dea: string;
    hin: string;
    specialty: string;
    primaryContactFirstName: string;
    primaryContactLastName: string;
    primaryContactEmail: string;
    phoneNumber: string;
    primaryGPO: string;
    primaryGPOID: string;
    secondaryGPO: string;
    secondaryGPOID: string;
    isActive: boolean;
    pdxIdentifier: string;
    parentId: string;
    entityCode: string;
    siteCode: string;
    isBilling: boolean;
    bccEmailAddress: string;
}